import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
  selector: 'vui-numbered-list-icon',
  templateUrl: './numbered-list-icon.component.html',
  styleUrls: ['./numbered-list-icon.component.scss']
})
export class NumberedListIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 27;
    }
}
